var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{attrs:{"shadow":"never","body-style":_vm.cardBodyStyle}},[_c('div',{staticClass:"left-container"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleAddFAQ}},[_vm._v(" 新增 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }